import { render, staticRenderFns } from "./getTicketType.vue?vue&type=template&id=7143e020&scoped=true"
import script from "./getTicketType.vue?vue&type=script&lang=js"
export * from "./getTicketType.vue?vue&type=script&lang=js"
import style0 from "./getTicketType.vue?vue&type=style&index=0&id=7143e020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7143e020",
  null
  
)

export default component.exports